import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false, // 请求正在加载
    userinfo: null, // 用户信息
    token: '', // token
    ContractInfo: {
      zyxdFundInfo: {},
    },
    withdrawObj: {},
    accessToken: '',
  },
  mutations: {
    UPDATELOADING(state) {
      state.isLoading = state;
    },
    setUserinfo(state, payload) {
      // 存储用户信息
      state.userinfo = payload;
    },
    setToken(state, token) {
      // 设置token
      state.token = token;
    },
    setContractInfo(state, ContractInfo) {
      // 设置合同详情
      state.ContractInfo = JSON.parse(JSON.stringify(ContractInfo));
    },
    setWithdrawObj(state, withdrawObj) {
      // 设置提现数据
      state.withdrawObj = JSON.parse(JSON.stringify(withdrawObj));
    },
    setAccessToken(state, accessToken) {
      // 设置accessToken
      state.accessToken = accessToken;
    },
  },
  actions: {},
});
